module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getSelectedEvent) ? _c('modal', {
    staticClass: "eventEdit-modal view dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "closemodal": _vm.cancelEdit,
      "close": _vm.cancelEdit
    }
  }, [_c('div', {
    staticClass: "fs-large mt-4 mb-3 text-center",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedEventTitle) + "\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "event-changed-banner bg-color-1 lightest text-center",
    class: {
      'active': _vm.hasSameEventUpdatedOnAnotherTab
    }
  }, [_vm._v("\n            This event was changed.\n            "), _c('span', {
    staticClass: "bold",
    staticStyle: {
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.reloadSelectedEvent
    }
  }, [_vm._v("Refresh")]), _vm._v("\n            to see the latest changes.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "eventEditBody d-flex position-relative"
  }, [(_vm.isloadingEvent) ? _c('div', {
    staticClass: "loading-overlay d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('loader'), _vm._v(" "), _c('span', {
    staticClass: "d-block mt-2 bold"
  }, [_vm._v("Loading Event")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 bg-lighter darker font-weight-600 px-0 flexGrow1"
  }, [_c('ul', {
    staticClass: "pt-1"
  }, [_vm._l((_vm.tabItems), function(tabItem) {
    return [(tabItem.visible == true) ? _c('li', {
      key: tabItem.area,
      staticClass: "py-3 pl-3 pointer",
      class: {
        'bg-light': tabItem.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectTabItem(tabItem)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(tabItem.label) + "\n                            "), (_vm.hasTabError(tabItem)) ? _c('span', {
      staticClass: "tab-error-dot"
    }) : _vm._e()]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 overflow-test"
  }, [_c(_vm.activeArea, {
    tag: "div",
    staticClass: "pb-4",
    attrs: {
      "validations": _vm.$v
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('footerButtons', _vm._b({
    attrs: {
      "validations": _vm.$v
    },
    on: {
      "cancelEdit": _vm.cancelEdit
    }
  }, 'footerButtons', {
    hasSameEventUpdatedOnAnotherTab: _vm.hasSameEventUpdatedOnAnotherTab,
    hasEventChangedOnOtherTab: _vm.hasEventChangedOnOtherTab,
    isloadingEvent: _vm.isloadingEvent
  }, false))], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ec31fdea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec31fdea"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit.vue
// module id = 1525
// module chunks = 0